<template>
	<div class="element-wrapper text-left">
		<h6 class="element-header capitalize">
			{{ t.navigation.roles }}
		</h6>
		<div class="element-box">
			<div class="element-content">
				<symForm :options="opt" :data="formData" v-on:sended="getForm" :form="form" :formProcess="formProcess" v-if="form"/>
			</div>
		</div>
	</div>
</template>

<script>

    import Choices from 'choices.js'
    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'userGroups',
        components: { symForm },
        props: {
            uid: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                session: window.session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                formData: [],
	            form: [],
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
            }
        },
        mounted () {
            this.getForm();
        },
        methods: {
            async groupsCh () {
		        var e = document.getElementsByClassName("choicesx");
		        for (var i = 0; i < e.length; i++){
		            var name = e[i].getAttribute("name");

		            var element = e[i];

		            var example = new Choices(element, {
		                removeItemButton: true,

		            });
		        }
		    },
            async getForm (data) {

		        if(this.session.uid > 0) {
		            this.form = null;
		            this.formProcess = 0;
		            this.$bus.$emit('globalLoader', true);
		            if(data) {
		                //this.userForm = null;
		                this.$http.post(api+'api/v1/form/roles/'+this.uid,
		                    data )
		                    .then(response => {

		                    this.form = response.body.result;
			                this.formProcess = 200;

			                swal('', this.t.processing.success, "success")
			                this.$bus.$emit('globalLoader', false);

                        setTimeout(this.groupsCh, 500)

		            }, response => {
		                    this.form = response.body.result;
		                    this.formProcess = 400;
		                    swal(this.t.processing.error, this.t.processing.check, "error")
		                    this.$bus.$emit('globalLoader', false);

                            setTimeout(this.groupsCh, 500)
		                })

		            } else {
		                this.$http.get(api+'api/v1/form/roles/'+this.uid)
		                    .then(response => {

		                    this.form = response.body.result;
			                this.formData = response.body.form_data;
			                this.$bus.$emit('globalLoader', false);
	                        this.formProcess = 200;

                            setTimeout(this.groupsCh, 500)

		            }, response => {
		                    this.$bus.$emit('globalLoader',false);
		                })
		            }
		        }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/userGroups.vue